<template>
  <div>
    <el-card class="box-card" body-style="min-height:60vh;">
      <div slot="header" class="clearfix">
        <el-form :inline="true" :model="searchForm" ref="searchForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="用户名称：" prop="name">
            <el-input v-model="searchForm.name" placeholder="请输入用户名称/手机号搜索" class="mt-search-width"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="searchTopBtn">查询</el-button>
          </el-form-item>
        </el-form>
        <el-button type="primary" @click="configOpenBtn">配置</el-button>
      </div>
      <div class="text item">
        <el-table
          border
          :data="infoList">
          <el-table-column
            align="center"
            prop="id"
            label="ID">
          </el-table-column>
          <el-table-column
            align="center"
            prop="applyName"
            label="申请人昵称">
          </el-table-column>
          <el-table-column
            align="center"
            prop="applyPhone"
            label="申请人电话">
          </el-table-column>
          <el-table-column
            align="center"
            prop="nickName"
            label="姓名">
          </el-table-column>
          <el-table-column
            align="center"
            prop="phone"
            label="联系方式">
          </el-table-column>
          <el-table-column
            align="center"
            prop="applyReason"
            label="申请理由">
          </el-table-column>
          <el-table-column
            align="center"
            prop="createTime"
            label="申请时间">
          </el-table-column>
          <el-table-column
            align="center"
            width="240"
            label="操作">
            <template slot-scope="scope">
              <el-button @click="detailOpenBtn(scope.row.id)" type="text" size="small">详情</el-button>
              <el-button v-if="scope.row.status === 1" @click="shAgreeOpenBtn(scope.row.id)" type="text" size="small">通过</el-button>
              <el-button v-if="scope.row.status === 1" @click="rejectOpenBtn(scope.row.id)" v-loading.fullscreen.lock="fullscreenLoading" type="text" size="small">驳回</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="mt-page-bottom flex-end-row">
          <pagination :total="pageTotal" :page="currentPage" :limit="limitLength" @pagination="paginationChangeBtn" />
        </div>
      </div>
    </el-card>
    <el-dialog
      title="审核通过"
      :visible.sync="shAgreeShow"
      width="960px">
      <el-form :model="shAgreeForm" label-width="140px">
        <el-form-item label="层级：" prop="applyType">
          <el-radio-group v-model="shAgreeForm.applyType">
            <el-radio :label="1">一级</el-radio>
            <el-radio :label="2">二级</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="shAgreeForm.applyType == 2" label="一级：" prop="parentId">
          <el-select v-model="shAgreeForm.parentId" placeholder="请选择" class="mt-search-width" style="width: 424px;">
            <el-option
              v-for="item in parentIdArr"
              :key="item.id"
              :label="item.nickName"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="shAgreeForm.applyType == 2" label="身份：" prop="commissionPromoterLevelId">
          <el-select v-model="shAgreeForm.commissionPromoterLevelId" placeholder="请选择" class="mt-search-width" style="width: 424px;">
            <el-option
              v-for="item in commissionPromoterLevelIdArr"
              :key="item.id"
              :label="item.promoterName"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="shAgreeSaveBtn" v-loading.fullscreen.lock="fullscreenLoading">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      title="审核驳回"
      :visible.sync="dialogVisible"
      width="960px">
      <el-form :model="cateForm" label-width="140px">
        <el-form-item label="理由：" prop="refuseReason">
          <el-input style="width:580px;" rows="6" type="textarea" v-model="cateForm.refuseReason" placeholder="请输入驳回理由"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="rejectSaveBtn" v-loading.fullscreen.lock="fullscreenLoading">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 详情弹窗 -->
    <el-drawer
      size="960px"
      :visible.sync="detailShow"
      :with-header="false">
      <dl-apply-detail :infoId="infoId"></dl-apply-detail>
    </el-drawer>
    <!-- 代理申请金额弹窗 -->
    <el-dialog
      title="代理申请金额"
      :visible.sync="configShow"
      width="960px">
      <el-form :model="configForm" label-width="140px">
        <el-form-item label="代理申请金额：" prop="agentApplyMoney">
          <el-input v-model="configForm.agentApplyMoney" placeholder="请输入代理申请金额" style="width: 424px;"></el-input>
        </el-form-item>
        <el-form-item label="代理申请规则：" prop="agentApplyRule">
          <editor :height="230" v-model="configForm.agentApplyRule"></editor>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="configSaveBtn" v-loading.fullscreen.lock="fullscreenLoading">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { queryCommissionUserApplyLogPageList, rejectApplication, approveApplication, queryFirstCommissionUserList, queryAllCommissionPromoterLevelList, fetchAgentApplyConfigDetail, saveOrUpdateAgentApplyConfig } from '@/api/commission'
import { saveOrUpdateShopConfig, fetchShopConfigDetail } from '@/api/shop'
import DlApplyDetail from './components/Detail.vue'
import Editor from '@/components/Editor.vue'
export default {
  name: 'DlApply',
  components: {
    DlApplyDetail,
    Editor
  },
  data () {
    return {
      imgServer: this.$imgServer,
      limitLength: this.$limitLength,
      baseUrl:this.$baseUrl,
      pageTotal: 0,
      currentPage: 1,
      infoList: [],
      fullscreenLoading: false,
      searchForm: {
        name:'',
        region:''
      },
      // 审核通过弹窗
      shAgreeShow:false,
      shAgreeForm: {
        applyType:1,
        parentId:'',
        commissionPromoterLevelId:''
      },
      parentIdArr:[],
      commissionPromoterLevelIdArr:[],
      // 审核驳回弹窗
      dataId:'',
      dialogVisible: false,
      cateForm:{
        refuseReason:''
      },
      // 详情弹窗
      detailShow:false,
      infoId:'',
      // 代理申请金额弹窗
      configShow:false,
      configForm:{
        agentApplyMoney:'',
        agentApplyRule:''
      }
    }
  },
  mounted () {
    this.getInfoList()
  },
  methods: {
    // 代理申请金额弹窗-打开操作
    configOpenBtn(){
      var that = this;
      fetchShopConfigDetail({}).then((res) => {
        if (res.errorCode === '0000') {
          var data = res.data;
          that.configForm.agentApplyMoney = data.agentApplyMoney;
          that.configForm.agentApplyRule = data.agentApplyRule;
          that.configShow = true;
        }
        if (res.errorCode === '1001') {
          this.$message.error(res.msg)
        }
      })
    },
    // 代理申请金额弹窗-保存操作
    configSaveBtn(){
      var that = this;
      that.fullscreenLoading = true
      saveOrUpdateShopConfig(that.configForm).then((res) => {
        that.fullscreenLoading = false
        if (res.errorCode === '0000') {
          this.$message({
            message: res.msg,
            type: 'success',
            onClose () {
              that.configShow = false;
            }
          })
        }
        if (res.errorCode === '1001') {
          this.$message.error(res.msg)
        }
      })
    },
    // 详情弹窗-打开操作
    detailOpenBtn(infoId){
      this.infoId = infoId;
      this.detailShow = true;
    },
    // 搜索操作
    searchTopBtn(){
      this.currentPage = 1;
      this.getInfoList();
    },
    // 获取数据
    getInfoList () {
      let that = this
      let searchName = that.searchForm.name
      let page = that.currentPage
      queryCommissionUserApplyLogPageList({ webSearchStr: searchName,pageNum: page, pageSize: that.limitLength}).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.infoList = data
          that.pageTotal = res.total
        }
        if (res.errorCode === '4002') {
          that.infoList = []
          that.pageTotal = res.total
        }
      })
    },
    // 分页改变操作
    paginationChangeBtn(val){
      this.currentPage = val.page;
      this.limitLength = val.limit;
      this.getInfoList();
    },
    /* 删除 */
    delBtn (infoId) {
      let that = this
      this.$confirm('确认删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.fullscreenLoading = true
        removeEnterpriseById({ ids: [infoId]}).then((res) => {
          that.fullscreenLoading = false
          if (res.errorCode === '0000') {
            this.$message({
              message: res.msg,
              type: 'success',
              onClose () {
                that.getInfoList()
              }
            })
          }
          if (res.errorCode === '1001') {
            this.$message.error(res.msg)
          }
        })
      }).catch(() => {})
    },
    // 审核通过弹窗-一级数据
    parentIdFun(){
      var that = this;
      queryFirstCommissionUserList({}).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.parentIdArr = data;
        }
      })
    },
    // 审核通过弹窗-身份数据
    commissionPromoterLevelIdFun(){
      var that = this;
      queryAllCommissionPromoterLevelList({}).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.commissionPromoterLevelIdArr = data;
        }
      })
    },
    /* 审核通过弹窗-打开 */
    shAgreeOpenBtn (dataId) {
      this.dataId = dataId
      this.parentIdFun();
      this.commissionPromoterLevelIdFun();
      this.shAgreeShow = true
    },
    /* 审核通过弹窗-保存 */
    shAgreeSaveBtn (dataId) {
      var that = this
      var dataId = that.dataId
      var applyType = that.shAgreeForm.applyType
      var parentId = that.shAgreeForm.parentId
      var commissionPromoterLevelId = that.shAgreeForm.commissionPromoterLevelId
      if (applyType === 2) {
        if(parentId == ''){
          this.$message.error('请选择一级')
          return false
        }
        if(commissionPromoterLevelId == ''){
          this.$message.error('请选择推广者身份')
          return false
        }
      }
      let passData = {
        id: dataId,applyType: applyType, parentId: applyType == 1 ? '' : parentId, commissionPromoterLevelId: applyType == 1 ? '' : commissionPromoterLevelId
      }
      approveApplication(passData).then((res) => {
        that.fullscreenLoading = false;
        if(res.errorCode == "0000"){
          that.dataId = '';
          that.shAgreeForm.applyType = 1;
          that.shAgreeForm.parentId = '';
          that.shAgreeForm.commissionPromoterLevelId = '';
          that.shAgreeShow=false;
          that.getInfoList();
        }
        if(res.errorCode == "1001"){
          that.$message.error(res.msg);
        }
      })
    },
    /* 审核驳回弹窗-打开 */
    rejectOpenBtn (dataId) {
      this.dataId = dataId
      this.cateForm.refuseReason = '';
      this.dialogVisible = true
    },
    // 审核驳回弹窗-保存
    rejectSaveBtn(){
      var that = this
      var dataId = that.dataId
      var refuseReason = that.cateForm.refuseReason
      if (refuseReason === '') {
        this.$message.error('请输入驳回原因')
        return false
      }
      let passData = {
        id: dataId,refuseReason: refuseReason
      }
      rejectApplication(passData).then((res) => {
        that.fullscreenLoading = false;
        if(res.errorCode == "0000"){
          that.dataId = '';
          that.cateForm.refuseReason = '';
          that.dialogVisible=false;
          that.getInfoList();
        }
        if(res.errorCode == "1001"){
          that.$message.error(res.msg);
        }
      })
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/commission/DlApply.vue